import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'reactstrap';
import { useIntl } from 'react-intl';

import DatePicker from 'src/componentes/date-picker';
import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import Input from 'src/componentes/input';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';

function CursosExtracurricularesEditView({ handleClose, item, indexItem,isRequired, ...rest }) {
  const intl = useIntl();
  const {terms: resources} = useAuth();
  const modalRef = useRef();
  const [currentItem, setCurrentItem] = useState(item);
  const [isNew] = useState(item == null);
  const handleCurrentClose = (isSaved = false) => {
    modalRef.current.close();
    setTimeout(() => {
      handleClose && handleClose(isSaved, isNew, currentItem, indexItem);
    }, 300);
  };

  const handleChange = (field, value) => {
    setCurrentItem((prev) => ({
      ...prev,
      permissions: {
        allowEdit: true,
        allowDelete: true,
      },
      [field]: value,
    }));
  };

  const handleCloseClick = () => {
    handleCurrentClose();
  };

  const handleSave = () => {
    handleCurrentClose(true);
  };

  const isDisabled = () => !currentItem || !currentItem.curso || !currentItem.instituicaoEnsino || !currentItem.dataConclusao;

  const editActions = [
    <Button key={1} onClick={handleCloseClick} color="secondary">
      {<FormattedMessage id="label.cancelar" />}
    </Button>,
    <Button key={2} disabled={isDisabled()} type="primary" onClick={handleSave} htmlType="submit" className="ml-2">
      {<FormattedMessage id="label.salvar" />}
    </Button>,
  ];

  return (
    <Dialog
      id="formacoes-academicas-edit"
      ref={modalRef}
      width={750}
      minHeight={250}
      title={capitalizeFirstLetter(
        intl.formatMessage({ id: 'cursosExtracurriculares' },{cursosextracurriculares : resources.cursosextracurriculares})
      )}
      padContent
      actions={editActions}
      onRequestClose={handleCurrentClose}
      {...rest}
    >
      <Row>
        <Col md={7}>
          <Input
            required={isRequired}
            model={{
              label: <FormattedMessage id="curso" />,
              value: currentItem && currentItem.curso,
              requestChange: (e) => handleChange('curso', e),
            }}
          />
        </Col>
        <Col md={4}>
          <DatePicker
            required={isRequired}
            autoFormatDate={true}
            timeFormat={false}
            model={{
              label: <FormattedMessage id="dataConclusao" />,
              value: currentItem && currentItem.dataConclusao,
              requestChange: (e) => handleChange('dataConclusao', e),
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={7}>
          <Input
            required={isRequired}
            model={{
              label: <FormattedMessage id="instituicaoEnsino" />,
              value: currentItem && currentItem.instituicaoEnsino,
              requestChange: (e) => handleChange('instituicaoEnsino', e),
            }}
          />
        </Col>
      </Row>
    </Dialog>
  );
}

export default CursosExtracurricularesEditView;
